import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {animate, animateChild, group, keyframes, query, state, style, transition, trigger} from '@angular/animations';

const animateTime = '0.3s ease-in-out';
const expansionTriggerClosedStyle = {
  width: '65px'
};
const expansionTriggerOpenStyle = {
  width: '220px'
};

const colExpansionClosedStyle = {
  opacity: 0,
  margin: '0 0 0 -30px'
};
const colExpansionOpenStyle = {
  opacity: 1,
  margin: '0 0 0 30px'
};

const rightPanelClosedStyle = {
  margin: '0 0 0 65px'
};
const rightPanelOpenStyle = {
  margin: '0 0 0 220px'
};
//
// Animations
// Expansion Trigger
function expansionTriggerAni(start, end) {
  return group([
    animate(animateTime, keyframes([
      style(start),
      style(end)
    ])),
    query('@colExpansion', group([
      animateChild()
    ])),
    query('@swipeRight', group([
      animateChild()
    ]))
  ]);
}
//
// *Exported* Triggers
export const expansionTriggerAnimation = trigger('expansionTrigger', [
  //
  // States
  state('on', style(expansionTriggerOpenStyle)),
  state('off', style(expansionTriggerClosedStyle)),
  //
  // Transitions
  transition(
    'on => off',
    expansionTriggerAni(expansionTriggerOpenStyle, expansionTriggerClosedStyle)
  ),
  transition(
    'off => on',
    expansionTriggerAni(expansionTriggerClosedStyle, expansionTriggerOpenStyle)
  ),
  transition( ':enter', [
    style({opacity: 0, transform: 'translateX(-50%)'}),
    animate('400ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
  ])
]);
export const colExpansionAnimation = trigger('colExpansion', [
  //
  // States
  state('on', style(colExpansionOpenStyle)),
  state('off', style(colExpansionClosedStyle)),
  //
  // Transitions
  transition('on <=> off', animate(animateTime))
]);

export const rightPanelAnimation = trigger('rightPanel', [
  //
  // States
  state('on', style(rightPanelOpenStyle)),
  state('off', style(rightPanelClosedStyle)),
  //
  // Transitions
  transition('on <=> off', animate(animateTime))
]);

export const swipeRightAnimation = trigger('swipeRight',[
  transition(':enter', [
    style({opacity: 0, transform: 'translateX(50%)'}),
    animate('200ms 0.3s cubic-bezier(0.35, 0, 0.25, 1)')
  ]),
  transition(':leave', [
    style({ opacity: 1}),
    animate('200ms cubic-bezier(0.35, 0, 0.25, 1)',
      style({ transform: 'translateX(-50%)', opacity: 0 }))
  ])
]);

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    expansionTriggerAnimation, colExpansionAnimation,
    rightPanelAnimation, swipeRightAnimation
  ]
})
export class MainComponent implements OnInit {

  isLoginUser = false;
  isOpenNavbar = 'on';
  name = '';
  email = '';
  currentYear;
  constructor(private router: Router, private _cdr: ChangeDetectorRef) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.isLoginUser = localStorage.getItem('currentUser') ? true : false;
    this.isOpenNavbar = localStorage.getItem('isOpenNavbar') === null ? 'on' : localStorage.getItem('isOpenNavbar');
    if (this.isOpenNavbar !== 'on' && this.isOpenNavbar !== 'off') {
      this.isOpenNavbar = 'on';
    }
    if (this.isLoginUser) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.name = currentUser['first_name'];
      this.email = currentUser['email'];
    }

    window.addEventListener('storage', (event) => {
      if (event.storageArea === localStorage) {
        const token = localStorage.getItem('currentUser');
        if (token === null) {
          this.router.navigate(['/login']);
        }
      }
    });
  }

  goToLogin(): void {
    localStorage.removeItem('currentUser');
    this.isLoginUser = false;
    this._cdr.detectChanges();
    this.router.navigate(['/login']);
  }

  toggleMenu(): void {
    if (this.isOpenNavbar === 'on') {
      this.isOpenNavbar = 'off';
    } else {
      this.isOpenNavbar = 'on';
    }
    localStorage.setItem('isOpenNavbar', this.isOpenNavbar);
  }

}
